export const isHuaweiWebview = () =>
  navigator?.userAgent?.toLowerCase?.()?.indexOf('androidapp') >= 0 ?? false;
